import api from "../../../services/api";

export interface ScheduleEntry {
  date: string;
  monthOffset: number;
  label: string;
  method: "card" | "sepa";
  ht: number;
  ttc: number;
  offered: boolean;
}

export interface ModeSummary {
  schedule: ScheduleEntry[];
  todayHtCents: number;
  todayTtcCents: number;
  annualHtCents: number;
  annualTtcCents: number;
  totalHtCents: number;
  totalTtcCents: number;
}

export type PaymentMode = "monthly" | "comptant_cb" | "comptant_alma";

export interface ActivationInfo {
  firstName: string;
  lastName: string;
  email: string;
  opticianName: string;
  brandName: string | null;
  currency: string;
  vatRate: number;
  engagementMonths: number;
  monthsOffered: number;
  activationFeeHtCents: number;
  annualFeeHtCents: number;
  monthlyHtCents: number;
  monthlyTtcCents: number;
  comptantDiscountRate: number;
  comptantSavingsHtCents: number;
  comptantSavingsTtcCents: number;
  modes: Record<PaymentMode, ModeSummary>;
  expiresAt: string;
  stripeCustomerId: string;
}

export interface PayResponse {
  success?: boolean;
  message?: string;
  redirectUrl?: string;
  requires_action?: boolean;
  payment_intent_client_secret?: string;
  payment_intent_id?: string;
}

export const fetchActivationInfo = async (token: string): Promise<ActivationInfo> => {
  const { data } = await api.get(`/activation/${token}`);
  return data;
};

export const payActivation = async (
  token: string,
  body: {
    paymentMode: "monthly" | "comptant_cb";
    cardPaymentMethodId: string;
    ibanPaymentMethodId?: string;
    password: string;
  }
): Promise<PayResponse> => {
  const { data } = await api.post(`/activation/${token}/pay`, body);
  return data;
};

export const confirm3ds = async (
  token: string,
  body: {
    paymentIntentId: string;
    ibanPaymentMethodId?: string;
    password: string;
  }
): Promise<PayResponse> => {
  const { data } = await api.post(`/activation/${token}/confirm-3ds`, body);
  return data;
};

export const almaCheckout = async (
  token: string,
  body: { password: string }
): Promise<{ url: string }> => {
  const { data } = await api.post(`/activation/${token}/alma-checkout`, body);
  return data;
};
